import Immutable from 'immutable'

export const RelationshipRecord = Immutable.Record({
  client_id: null,
  partner: false,
  roles: Immutable.Set(),
  user: null, // id
}, 'Relationship')

export default function createRelationship({
  user,
  roles = [],
  ...data
}) {
  return new RelationshipRecord({
    ...data,
    roles: Immutable.Set(roles),
    user: user ? user.id : null,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Relationship.js